import { Button, Container, Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { AccelOneLogo, CandidateViewerLogo } from '../../assets/images';
import { COLORS } from '../../constants/colors';
import ActionButtons from '../actionButtons';
import { useUser } from '../../hooks';
import { HOME_PATH } from '../../config/routes';
import { Link } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';


const useStyles = makeStyles({
  header: {
    backgroundColor: COLORS.grayScale[0],
    // ['@media (max-width:680px)']: {
    //   height:"150px",
    // }
  },
  container: {
    maxWidth: '90rem',
    padding: '0 3.125rem',
    ['@media (max-width:799px)']: {
       padding:'0 3% 0 3%',
    },
    ['@media (max-width:680px)']: {
      padding:'1em 3% 0 3%',
    }
  },
  containerPublic: {
    maxWidth: '90rem',
    padding: '0 3.125rem',
  },
  grid: {
    height: '6.25rem',
  },
  gridChildren: {
    height: '6.25rem',
    ['@media (max-width:900px)']: {
      height: '7.25rem',
   },
    ['@media (max-width:680px)']: {
      height: '8.25rem',
   },
  },
  gridPublic: {
    height: '6.25rem',
    ['@media (max-width:680px)']: {
      justifyContent: 'center',
      marginTop:10,
    }
  },
  accelOne: {
    height: '3.3125rem'
  },
  candidateViewer: {
    height: '2.1875rem',
    marginTop:10,
    ['@media (max-width:799px)']: {
      height:30,
      marginBottom:-10,
    },
    ['@media (max-width:680px)']: {
      height:20,
      margin:'0px 0px 10px 0px',
    }
  },
  candidateViewerPublic: {
    height: '2.1875rem',
    margin:'28px 0 0 0',
    ['@media (max-width:680px)']: {
      height:20,
      margin:'0 0 10px 0',
      display:'block'
    }
  },
  user: {
    margin: '-10px 0px -10px 0px',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex',
    alignItems:'center',
    ['@media (max-width:680px)']: {
      display:'inline-flex',
      float:'right',
      margin: '-15px 0 0 0',
    },
  },
  userChildren: {
    margin: '-10px 0px -10px 0px',
    textAlign: 'center',
    justifyContent: 'center',
    display: 'flex',
    alignItems:'center',
    ['@media (max-width:680px)']: {
      right:10,
      position:'absolute',
      margin: '-5px 0 0 0',
    },
  },
  actionButtons: {
    margin: '2em',
    ['@media (max-width:680px)']: {
      margin:0,
    }
  },
  grid100: {
    //margin: '0em',
    ['@media (max-width:680px)']: {
      width:'100%',
    }
  },
  logout: {
    ['@media (max-width:509px)']: {
      //margin:'0px 6px 0px 12px',
      height:'2em',
    }
  },
  email: {
    ['@media (max-width:509px)']: {
      display:'none',
    }
  },
  editButton: {
    //margin: '0em',
    ['@media (max-width:680px)']: {
      height:'2em',
    }
  },
});

const Header = ({ children, withActions, onEdit, onDelete, onCancel }) => {
  const classes = useStyles();
  const { user, isUserLoggedIn, logout } = useUser();
  const size = useWindowSize();

  return (
    <header className={classes.header}>
      <Container className={isUserLoggedIn && !children ? classes.container:classes.containerPublic}>
        <Grid
          className={isUserLoggedIn ? children? classes.gridChildren:classes.grid : classes.gridPublic}
          container
          justify="space-between"
          alignItems="center"
        >
          <Grid item>
            <Link to={HOME_PATH}>
              <img
                className={classes.accelOne}
                src={AccelOneLogo}
                alt="AccelOne logo"
              />
              {!isUserLoggedIn && size.width<681 &&
              <img
                className={classes.candidateViewerPublic}
                src={CandidateViewerLogo}
                alt="Candidate Viewer logo"
              />}
            </Link>
          </Grid>
          {!isUserLoggedIn && size.width>680 &&
            <Grid item>
              <img
                className={classes.candidateViewerPublic}
                src={CandidateViewerLogo}
                alt="Candidate Viewer logo"
              />
            </Grid>
          }
          {children && size.width>899 && <Grid item> {children} </Grid>}
          {isUserLoggedIn &&(
            <>
            {withActions &&
            <Grid item className={classes.actionButtons}>
              <ActionButtons onEdit={onEdit} onDelete={onDelete} onCancel={onCancel} className={classes.editButton}/>
            </Grid>
            }
            {children && withActions && <Grid item> </Grid>}
            
          <Grid item className={classes.grid100}>
            <img
              className={classes.candidateViewer}
              src={CandidateViewerLogo}
              alt="Candidate Viewer logo"
            />
              <div className={children? classes.userChildren:classes.user}>
                <div className={classes.email}>
                  {user.email}
                </div>
                <Button variant={size.width>509?"text":"outlined"} color="primary" onClick={logout} className={classes.logout}>
                  {size.width>509?"( Exit )":"Exit"}
                </Button>
              </div>
          </Grid>
          </>
          )}
          {children && size.width<900 && 
          <Grid item sm={12} >
            <Grid justifyContent="center" >
              <Grid item > {children} </Grid>
            </Grid>
          </Grid>
          }
        </Grid>
      </Container>
    </header>
  );
};

export default Header;
